import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CustomDataGrid from "src/@core/components/data-grid";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import moment from "moment";

function PermissionListTable({
  rows,
  totalCount,
  setCurrentPage,
  currentPage,
  setPageSize,
  pageSize,
  toggleDelete,
  onSuccess,
  onEdit,
}) {
  const [editOpen, setEditOpen] = useState(false);
  const [selectedPermission, setSelectedPermission] = useState(null);
  const [viewOpen, setViewOpen] = useState(false);

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "active":
        return "#6DA544";
      case "inactive":
        return "#E56060";
      case "pending":
        return "#9160E5";
      default:
        return "#667085";
    }
  };

  const navigate = useNavigate();

  const handleEditOpen = (permission) => {
    if (onEdit) {
      onEdit(permission);
    }
  };

  const handleViewOpen = (permission) => {
    setSelectedPermission(permission);
    setViewOpen(true);
  };

  const handleEditClose = () => {
    setEditOpen(false);
    setSelectedPermission(null);
  };

  const handleViewClose = () => {
    setViewOpen(false);
    setSelectedPermission(null);
  };

  return (
    <>
      <CustomDataGrid
        rows={rows}
        rowCount={totalCount}
        getRowClassName={(params) => {
          // Add special styling for agent row
          return params.row.userType === "agent" ? "agent-row" : "";
        }}
        sx={{
          "& .agent-row": {
            backgroundColor: "#F8F9FA",
            fontWeight: "bold",
            "& .MuiDataGrid-cell": {
              borderBottom: "2px solid #E0E0E0",
            },
          },
        }}
        columns={[
          {
            field: "id",
            headerName: "ID",
            minWidth: 80,
            sortable: false,
            renderCell: ({ row }) => (
              <Typography
                variant="fm-p3"
                color="#101828"
                fontWeight="500"
                noWrap
              >
                {row?.id || "-"}
              </Typography>
            ),
          },
          {
            field: "name",
            headerName: "Permission Name",
            minWidth: 250,
            sortable: false,
            renderCell: ({ row }) => (
              <Typography
                variant="fm-p3"
                color="#101828"
                fontWeight="500"
                noWrap
                textTransform="capitalize"
              >
                {row?.name || "-"}
              </Typography>
            ),
          },
          {
            field: "created_at",
            headerName: "Created At",
            minWidth: 200,
            sortable: false,
            renderCell: ({ row }) => {
              return (
                <Typography variant="fm-p3" color="#101828" fontWeight="500" noWrap>
                  {row?.created_at ? moment(row.created_at).format("MMM DD, YYYY hh:mm A") : "-"}
                </Typography>
              )
            }
          },
          {
            field: "updated_at",
            headerName: "Updated At",
            minWidth: 200,
            sortable: false,
            renderCell: ({ row }) => {
              return (
                <Typography variant="fm-p3" color="#101828" fontWeight="500" noWrap>
                  {row?.updated_at ? moment(row.updated_at).format("MMM DD, YYYY hh:mm A") : "-"}
                </Typography>
              )
            }
          },
          {
            field: "actions",
            headerName: "Action",
            minWidth: 200,
            sortable: false,
            renderCell: ({ row }) => (
              <Box display="flex" gap="10px">
                <IconButton
                  onClick={() =>
                    navigate(`/permissions/edit/${row.id}`, {
                      state: { dataToEdit: row },
                    })
                  }
                  sx={{ bgcolor: "#F9FCE1", borderRadius: "8px", p: 2 }}
                  size="small"
                >
                  <EditIcon />
                </IconButton>
                <IconButton
                  sx={{ bgcolor: "#FCE8E1", borderRadius: "8px", p: 2.5 }}
                  size="small"
                  color="secondary"
                  onClick={(e) => toggleDelete(e, row, "permission")}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            ),
          },
        ]}
        currentPage={currentPage}
        pageSize={pageSize}
        setCurrentPage={setCurrentPage}
        setPageSize={setPageSize}
      />
    </>
  );
}

export default PermissionListTable;